/**
 * Created by lixinwei on 17/7/13.
 */
import axios from 'axios'
import store from '../vuex/store'
import router from '../router/index'
// import qs from 'qs'
import API from './api'

const instance = axios.create();
// axios配置
// instance.defaults.baseURL = API._URL;
//instance.defaults.timeout = 600000;
instance.defaults.timeout = 600000;
instance.defaults.transformResponse = [
    function (data) {
        data = typeof (data) === 'string' ? JSON.parse(data) : data;

        if (data.rc !== 0) {
            // throw new Error(JSON.stringify(data));
        }

        return data;
    }
];

// 添加请求拦截器
instance.interceptors.request.use((config) => {
    store.dispatch('show_loading');
    if (store.state.token) {
        config.headers.Authorization = 'testAuthor' + `${store.state.token}`;
    }
    return config;
}, (error) => {
    store.dispatch('hide_loading');
    return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use((response) => {
    store.dispatch('hide_loading');
    return response;
}, (error) => {
    if (error.response) {
        switch (error.response.status) {
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                // $.toast('登录超时')
                store.dispatch('remove_token');
                router.replace({
                    path: '/',
                    query: { redirect: router.currentRoute.fullPath }
                })
        }
    }
    store.dispatch('hide_loading');
    return Promise.reject(error)   // 返回接口返回的错误信息
});

export default instance;



// WEBPACK FOOTER //
// ./src/config/request.js